// extracted by mini-css-extract-plugin
export default {"Bar":"MobilePageHeader_Bar__jO9Rq","Stuck":"MobilePageHeader_Stuck__09S8I","Title":"MobilePageHeader_Title__DTYBv","Actions":"MobilePageHeader_Actions__S7ylx"};